export default function NumberFormat({
  children,
  locale,
  options = {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  }
}) {
  if (typeof children !== "number") return children;
  if (Number.isNaN(children)) return null;
  return children.toLocaleString(locale, options);
}
